import React, { useEffect } from "react";
import { Navigate, useRoutes } from "react-router";
import { lazy } from "react";
import AdminPanelLayout from "../components/admin-panel/admin-panel-layout";
import Admin from "../pages/admin/Admin";
import Company from "../pages/company/Company";
import User from "../pages/user/User";
import Login from "../pages/authentication/Login";
import SuperAdmin from "../pages/super-admin/SuperAdmin";
import ViewAdmin from "../pages/admin/ViewAdmin";
import MyProfile from "../pages/my-profile/MyProfile";
import Success from "../pages/payment/Success";
import Failure from "../pages/payment/Failure";
import PublicRoute from "../components/PublicRoute";
import SuperAdminService from "../services/superAdmin";
import { useDispatch } from "react-redux";
import { setUser } from "../store/slices/superAdmin";
import { toastError } from "../components/ToastNotification";
import Documents from "../components/Documents";
import PrivateRoute from "../components/PrivateRoute";
import Inquiry from "../pages/inquiry/Inquiry";

const SuspenseLoader = (Component) => (props) =>
(
  <React.Suspense fallback={<withLoader />}>
    <Component {...props} />
  </React.Suspense>
);

const Home = SuspenseLoader(
  lazy(() => import("../components/admin-panel/admin-panel-layout"))
);
function RedirectionWrapper({ to }) {
  const queryString = window.location.search;
  if (queryString) {
    return <Navigate to={`${to}${queryString}`} />;
  }
  return <Navigate to={to} />;
}
const routes = (isLoggedin) => [
  {
    path: "/",
    element: <AdminPanelLayout />,
    children: [
      {
        element: <RedirectionWrapper to="/admin" />,
        index: true,
      },
      {
        path: "/super-admin",
        element: <SuperAdmin />,
      },
      {
        path: "/admin",
        element: (
          <PrivateRoute>
            <Admin />
          </PrivateRoute>
        ),
      },
      {
        path: "/inquiry",
        element: (
          <PrivateRoute>
            <Inquiry />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/view-admin",
        element: (
          <PrivateRoute>
            <ViewAdmin />
          </PrivateRoute>
        ),
      },
      {
        path: "/company",
        element: (
          <PrivateRoute>
            <Company />
          </PrivateRoute>
        ),
      },
      {
        path: "/user",
        element: (
          <PrivateRoute>
            <User />
          </PrivateRoute>
        ),
      },
      {
        path: "/profile",
        element: (
          <PrivateRoute>
            <MyProfile />
          </PrivateRoute>
        ),
      },
      {
        path: "/documents",
        element: (
          <PrivateRoute>
            <Documents />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: "/login",
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: "/payment/success",
    element: <Success />,
  },
  {
    path: "/payment/fail",
    element: <Failure />,
  },
];

export default function Routes(props) {
  const dispatch = useDispatch();
  const { isLoggedin } = props;

  const getUserDetails = async () => {
    try {
      const response = await SuperAdminService?.getProfile();
      if (response) {
        dispatch(setUser(response?.data?.data));
      }
    } catch (error) {
      console.log("🚀  getUserDetails  error:", error);
      // toastError(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (isLoggedin) {
      getUserDetails();
    }
  }, [isLoggedin]);
  return useRoutes(routes(isLoggedin));
}
